import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { twitterIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useShareContext } from '../../context/ShareContext';

interface TwitterShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const TwitterShareRound: React.FunctionComponent<TwitterShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { shareItems } = useShareContext();

  const handleClick = () => {
    const twitterHref = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      shareItems.twitter.url,
    )}&text=${encodeURIComponent(shareItems.twitter.message)}`;

    onClick();

    window.open(twitterHref, 'newwindow', 'width=600,height=300');
  };

  return (
    <IconButton
      className={`${styles.roundButton} ${className}`}
      onClick={handleClick}
    >
      <div className={classNames(styles.iconWrapper, styles.twitter)}>
        <Svg markup={twitterIcon} className={styles.icon} />
      </div>
      Twitter
    </IconButton>
  );
};
